import { ConnectorStatusColor } from '@services/constants'
import { pathOr } from 'ramda'
import styled from 'styled-components'

const ConnectorStatusLabel = (props: {
  status: number
  statusStr: string
  type: 'tag' | 'text'
}) => {
  const { status, type, statusStr, ...others } = props

  const color = pathOr('#fff', [status], ConnectorStatusColor)

  if (type === 'tag') {
    return (
      <TagLabel color={color} {...others}>
        {statusStr}
      </TagLabel>
    )
  }

  return (
    <TextLabel color={color} {...others}>
      {statusStr}
    </TextLabel>
  )
}

export default ConnectorStatusLabel

const TextLabel = styled.span<{ color: string }>`
  color: ${props => props.color};
  font-weight: 400;
  line-height: 1.5;
  text-align: center;
`
const TagLabel = styled.div<{ color: string }>`
  background-color: ${props => props.color};
  color: #272727;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  text-align: center;
  border-radius: 15px;
  padding: 5px;
`
